import { useParams } from "@tanstack/react-router";
import { useMailbox } from "../../hooks/use-mailbox";
import { ThreadDetail } from "../../components/mail/thread-detail";

export function ThreadDetailRoute() {
  const { threadId } = useParams({ strict: false }) as { threadId: string };
  const { mailboxId, selfEmail } = useMailbox();
  return <ThreadDetail mailboxId={mailboxId} threadId={threadId} selfEmail={selfEmail} />;
}
